import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      'Find Programs Near You': 'Find Programs Near You',
      'Zip Code': 'Zip Code',
      'Enter your zip code': 'Enter your zip code',
      'Search Radius (miles)': 'Search Radius (miles)',
      'miles': 'miles',
      'Searching...': 'Searching...',
      'Search Programs': 'Search Programs',
      'Please enter a zip code': 'Please enter a zip code',
      'Failed to search programs. Please try again.': 'Failed to search programs. Please try again.',
      'miles away': 'miles away',
      'Services': 'Services',
      'Eligibility': 'Eligibility',
      'Contact Information': 'Contact Information',
      'Phone': 'Phone',
      'Email': 'Email',
      'Website': 'Website',
      'Address': 'Address',
      'Search programs': 'Search programs',
      'Open video advisor': 'Open video advisor',
      'Selected Need': 'Selected Need',
      'Found': 'Found',
      'programs': 'programs',
      'near': 'near',
      'Visit': 'Visit'
    }
  },
  es: {
    translation: {
      'Find Programs Near You': 'Encuentre Programas Cerca de Usted',
      'Zip Code': 'Código Postal',
      'Enter your zip code': 'Ingrese su código postal',
      'Search Radius (miles)': 'Radio de Búsqueda (millas)',
      'miles': 'millas',
      'Searching...': 'Buscando...',
      'Search Programs': 'Buscar Programas',
      'Please enter a zip code': 'Por favor ingrese un código postal',
      'Failed to search programs. Please try again.': 'Error al buscar programas. Por favor intente de nuevo.',
      'miles away': 'millas de distancia',
      'Services': 'Servicios',
      'Eligibility': 'Elegibilidad',
      'Contact Information': 'Información de Contacto',
      'Phone': 'Teléfono',
      'Email': 'Correo Electrónico',
      'Website': 'Sitio Web',
      'Address': 'Dirección',
      'Search programs': 'Buscar programas',
      'Open video advisor': 'Abrir asesor de video',
      'Selected Need': 'Necesidad Seleccionada',
      'Found': 'Encontrado',
      'programs': 'programas',
      'near': 'cerca de',
      'Visit': 'Visitar'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 